import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import { signOutUrl } from "../../api/user/api.js";
import { clearSessionIdentity } from "../../Context/sessionIdentity.js";

/**
 * Signing out, wherever a user needs it.
 *
 * Kept as a link so it behaves like one — middle-click, copy address — with the
 * identity record cleared on the way out so a clean sign-out leaves nothing for
 * the next session to be compared against.
 *
 * Shared rather than inlined because a page that cannot offer sign-out is a page
 * a user cannot leave: the state where an account holds no memberships is
 * reachable, renders no navigation, and would otherwise trap whoever landed
 * there.
 */
export const SignOutButton = ({
  size = "small",
}: {
  size?: "small" | "medium";
}) => {
  const { t } = useTranslation();

  return (
    <Button
      size={size}
      href={signOutUrl()}
      // Clearing the record and following the link do not race. Both are
      // synchronous, and a browser performs a link's default action only after
      // the click handlers have run — so the record is gone before the
      // navigation starts. Nor can it strand a sign-out: clearing swallows a
      // storage failure, so the navigation happens either way.
      onClick={() => {
        clearSessionIdentity();
      }}
    >
      {t("auth.signOut")}
    </Button>
  );
};
